import Drawer, { drawerClasses } from '@mui/material/Drawer';
import { styled } from '@mui/material';

// Drawer lateral de Play con el MISMO lenguaje que "Detalle de la sesión"
// (StyledSessionDrawer): superficie sidebar + hairline + sombra profunda. Diferencias a
// propósito: más ancho (560px) para que las cards de ejercicios respiren, y SIN padding
// propio (el contenido maneja su cabecera sticky y su scroll interno).
const StyledPlayDrawer = styled(Drawer)(({ theme }) => ({
  [`& .${drawerClasses.paper}`]: {
    background: theme.palette.surface.sidebar,
    backgroundImage: 'none',
    borderLeft: `1px solid ${theme.palette.hairline.main}`,
    boxShadow: theme.palette.shadow.menu,
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '560px'
    }
  }
}));

export default StyledPlayDrawer;
